var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFreelance = function SvgFreelance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.652 29.072V48H1.35V29.072l24.044 1.577v-1.577L.9 27.495l-.9-.226V10.141h13.484V5.633c0-.903.225-1.577.45-2.254s.675-1.125 1.123-1.802c.45-.452 1.122-.903 1.797-1.126C17.53.226 18.202 0 18.877 0h22.246c.9 0 1.573.226 2.248.451.675.226 1.122.677 1.572 1.126.676.677.9 1.125 1.348 1.802.225.677.225 1.351.225 2.254v4.508H60v17.128l-.9.226-24.27 1.577v1.577l23.82-1.577h.002zm-27.32.707V32h-1.664v-2.221c-.334-.222-.668-.445-.668-.89 0-.444.668-.889 1.665-.889.667 0 1.335.445 1.335.89 0 .444-.334.667-.668.889zM34 25h-6v8h6v-8zM19.002 10H43V5H19.233L19 5.228V10h.002z",
    fillRule: "evenodd"
  })));
};

export default SvgFreelance;